import {PdfTemplateDescriptor} from "./PdfTemplateDescriptor";
import {Utility} from "../core/Utility";
import {PdfTemplateDynamicField} from "./PdfTemplateDynamicField";
import {Formater} from "../core/Formater";
var _ = require('lodash');

export class PdfTemplatePopulator {

	pdfTemplate: any;
	dependencies: any;
	counter: any;

	constructor() {
		this.dependencies = null
		this.counter = 0;
	}

	setDependency (data: any) {
		this.dependencies = data;
	}

	populateRecursively(obj: any, pdfDesc: PdfTemplateDescriptor, path: string) {

		var memorandum = false;

		for (var property in obj) {

			if (obj.hasOwnProperty(property)) {
				if (typeof obj[property] == "object") {
					//console.log(path);
					//console.log(obj);
					this.populateRecursively(obj[property], pdfDesc, path + "->" + property);
				} else {
					var fields = pdfDesc.dynamicFields;
					for (var i = 0; i < fields.length; i++) {
						var field = fields[i],
							value;
						if (property == "text" || property == "image") {
							value = this.getDependencyData(field);
							if (field.format == "price") value = Formater.formatPrice(value, 2)
							else if (field.format == "paymentDate") {
								value = value ? Utility.formatDate(value) : "";
							}
							try {
								obj[property] = obj[property].replace("{{" + field.key + "}}", value);
							} catch (err) {
								console.log(err);
							}
						}
						else if (property == "tableBodyToFill") {
							var fieldKey = obj[property],
								rowTemplate = obj["tableBodyTemplate"],
								tableBody = obj["body"];
							if (fieldKey == field.key) {
								this.populateTable(field, rowTemplate, tableBody);
								if (tableBody.length == 0) {
									tableBody.push([])
									delete obj['widths']
								}
							}
						}
					}
				}
			}
		}
	}

	populateTable (field: PdfTemplateDynamicField, rowTemplate: any, tableBody: any) {
		var rows = this.getDependencyData(field);

		for (var j=0; j<rows.length; j++) {
			var row = _.cloneDeep(rowTemplate)
			for (var i=0; i<row.length; i++) {
				var cell = row[i],
					regEx = new RegExp("\{\{(.*?)\}\}"),
					match = regEx.exec(cell["text"]);

				cell["text"] = cell["text"].replace("{{ROW_NUMBER}}",  (j+1).toString());

				if (cell["text"].includes("{{ROW_GLOBAL_NUMBER}}")) {
					cell["text"] = cell["text"].replace("{{ROW_GLOBAL_NUMBER}}", (this.counter + 1).toString());
					this.counter++;
				}

				if (match != null) {
					var textToReplace = match[0],
						attributeName = match[1],
						replaceWith = rows[j][attributeName]
					if (cell["format"] == "price") {
						replaceWith = Formater.formatPrice(rows[j][attributeName], 2)
					}
					cell["text"] = cell["text"].replace(textToReplace,  replaceWith);
				}

				if (cell["text"] == null || cell["text"] == "undefined") cell["text"] = "-"
			}
			tableBody.push(row);
		}
	}

	getDependencyData (field: PdfTemplateDynamicField) {

		if (Utility.isNullOrUndefined(this.dependencies[field.attribute])) return ''
		return this.dependencies[field.attribute]
	}
}
